<template>
  <div class="bg-page-container">
    <!-- 页面头部 -->
    <div class="bg-page-header">
      <div class="header-title">
        <i class="el-icon-s-unfold"></i>
        <span>单元管理</span>
      </div>
      <div class="header-actions">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="createInit">新增单元</el-button>
      </div>
    </div>

    <!-- 查询区域 -->
    <div class="bg-query-section">
      <div class="query-form">
        <el-form :inline="true" size="small">
          <el-form-item label="单元编号">
            <el-autocomplete
              v-model="keyword"
              :fetch-suggestions="querySearch"
              placeholder="请输入单元编号"
              @select="handleSelect"
              clearable
              style="width: 250px">
              <i class="el-icon-search el-input__icon" slot="suffix" @click="handleIconClick"></i>
            </el-autocomplete>
          </el-form-item>
        </el-form>
        <div class="query-actions">
          <el-button type="primary" icon="el-icon-search" size="small" @click="getUnits">查询</el-button>
          <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
        </div>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="bg-table-section">
      <el-table
        :data="unitList"
        v-loading="loading"
        :height="tableHeight"
        class="bg-table"
        stripe>
        <el-table-column prop="unitNo" label="单元编号" min-width="120" align="center">
        </el-table-column>
        <el-table-column prop="unitTitle" label="单元标题" min-width="300" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              @click="modifyUnit(scope.$index, scope.row)">
              修改
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="bg-pagination"
        background
        :page-size="pageSize"
        :current-page="pageIndex"
        @current-change="currentChange"
        :total="totalCount"
        :page-sizes="[15, 30, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>

    <!-- 空状态 -->
    <bg-empty
      v-if="!loading && unitList.length === 0"
      icon="el-icon-s-unfold"
      description="暂无单元数据"
      hint="请使用查询条件筛选或添加新单元">
    </bg-empty>

    <!-- 新增对话框 -->
    <el-dialog title="新增单元" :visible.sync="dialogVisible" width="450px" class="bg-dialog" :before-close="handleClose">
      <el-form ref="form" :model="unit" label-width="90px" size="small">
        <el-form-item label="单元编号" required>
          <el-input v-model="unit.unitNo" placeholder="请输入单元编号"></el-input>
        </el-form-item>
        <el-form-item label="单元标题" required>
          <el-input v-model="unit.unitName" placeholder="请输入单元标题"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveUnit" :loading="loading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 修改对话框 -->
    <el-dialog title="修改单元" :visible.sync="dialogmodVisible" width="450px" class="bg-dialog" :before-close="handleClose">
      <el-form ref="form" :model="unit" label-width="90px" size="small">
        <el-form-item label="单元编号">
          <el-input v-model="unit.unitNo" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="单元标题" required>
          <el-input v-model="unit.unitName" placeholder="请输入单元标题"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogmodVisible = false">取消</el-button>
        <el-button type="primary" @click="modifyUnitPost" :loading="loading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/utils/api'
import BgEmpty from '@/components/common/BgEmpty'

export default {
  name: 'Units',
  components: {
    BgEmpty
  },
  data () {
    return {
      tableHeight: 0,
      alertTip: false,
      alertaddTip: false,
      keyword: '',
      loading: false,
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      unitList: [],
      dialogVisible: false,
      dialogmodVisible: false,
      unit: {
        unitNo: '',
        unitName: ''
      }
    }
  },
  created () {
    this.tableHeight = (window.innerHeight - 240)
    this.getUnits()
  },
  methods: {
    createInit () {
      this.dialogVisible = true
      this.unit = {
        unitNo: '',
        unitName: ''
      }
    },
    saveUnit () {
      if (this.unit.unitNo === '' || this.unit.unitName === '') {
        this.$message({ message: '单元编号和标题不允许为空', type: 'warning' })
        return
      }
      this.loading = true
      this.$axios.post(api.createUnit, { UnitNo: this.unit.unitNo, UnitTitle: this.unit.unitName })
        .then(res => {
          if (res.data.result === 1) {
            this.getUnits()
            this.dialogVisible = false
            this.$message({ message: '新增成功', type: 'success' })
          } else if (res.data.result === 0) {
            this.$message({ message: '单元已存在', type: 'warning' })
          } else if (res.data.result === 2) {
            this.$message({ message: '不存在此单元编号', type: 'warning' })
          }
          this.loading = false
        })
    },
    getUnits () {
      this.loading = true
      this.$axios.post(api.getUnits, { PageIndex: this.pageIndex, PageSize: this.pageSize, UnitNo: this.keyword })
        .then(res => {
          this.loading = false
          this.unitList = res.data.result.items
          this.totalCount = res.data.result.totalCount
        })
    },
    modifyUnit (id, row) {
      this.dialogmodVisible = true
      this.unit.unitNo = row.unitNo
      this.unit.unitName = row.unitTitle
      this.alertTip = false
    },
    modifyUnitPost () {
      if (this.unit.unitName === '') {
        this.$message({ message: '单元标题不允许为空', type: 'warning' })
        return
      }
      this.loading = true
      this.$axios.post(api.modifyUnit, { UnitNo: this.unit.unitNo, UnitTitle: this.unit.unitName })
        .then(res => {
          this.loading = false
          this.dialogmodVisible = false
          this.$message({ message: '修改成功', type: 'success' })
          this.getUnits()
        })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getUnits()
    },
    handleClose () {
      this.dialogmodVisible = false
      this.dialogVisible = false
      this.alertTip = false
    },
    handleSelect (item) {
      this.keyword = item.Id
      this.getUnits()
    },
    handleIconClick () {
      this.getUnits()
    },
    querySearch (keyword, callback) {
      if (keyword === '') {
        return
      }
      var queryList = []
      this.$axios.get(api.unitAutocomplete(this.keyword))
        .then(res => {
          res.data.result.forEach((item, index) => {
            queryList.push({ value: item.unitNo, Id: item.unitNo })
          })
        })
      return callback(queryList)
    },
    currentChange (current) {
      this.pageIndex = current
      this.getUnits()
    },
    resetQuery () {
      this.keyword = ''
      this.pageIndex = 1
      this.getUnits()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.bg-page-container {
  @include page-container;
}

.bg-page-header {
  @include flex-between;
  margin-bottom: $spacing-lg;
  padding: $spacing-md $spacing-lg;
  background: var(--bg-white);
  border-radius: $border-radius-base;
  box-shadow: var(--shadow-base);

  .header-title {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    font-size: $font-size-lg;
    font-weight: 600;
    color: var(--text-primary);

    i {
      font-size: $font-size-xl;
      color: $primary-color;
    }
  }
}

.bg-query-section {
  background: var(--bg-white);
  border-radius: $border-radius-base;
  padding: $spacing-lg;
  margin-bottom: $spacing-lg;
  box-shadow: var(--shadow-base);

  .query-form {
    @include flex-between;
    flex-wrap: wrap;
    gap: $spacing-md;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .query-actions {
    display: flex;
    gap: $spacing-sm;
  }
}

.bg-table-section {
  @include table-section;

  .bg-table {
    border-radius: $border-radius-sm;
    overflow: hidden;

    .el-table__header {
      background: var(--gradient-header);

      th {
        font-weight: 600;
        color: var(--text-primary);
        background: transparent;
      }
    }
  }
}

.bg-pagination {
  margin-top: $spacing-lg;
  text-align: center;
}

// 响应式适配
@media (max-width: $screen-md) {
  .bg-query-section {
    .query-form {
      flex-direction: column;
      align-items: stretch;

      .query-actions {
        justify-content: flex-start;
      }
    }
  }
}

@media (max-width: $screen-sm) {
  .bg-page-header {
    flex-direction: column;
    gap: $spacing-md;
    align-items: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bg/Units.vue